
export const DROPPED_FILE: string = 'DROPPED_FILE';

export const DEFAULT_IMAGE_NAME: string = 'DEFAULT_IMAGE_NAME';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants.ts